import _ from 'lodash';

export default class Modal {
  constructor(modals) {
    this.modals = modals;
  }

  show(modal) {
    document.body.classList.add('modal-open');
    this.modals[_.camelCase(modal)] = true;
  }

  hide(modal) {
    document.body.classList.remove('modal-open');
    this.modals[_.camelCase(modal)] = false;
  }

  hideAll() {
    document.body.classList.remove('modal-open');
    Object.keys(this.modals).forEach((key) => {
      this.modals[key] = false;
    });
  }

  isVisible(modal) {
    return this.modals[_.camelCase(modal)];
  }
}
